import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { PortfolioProvider } from "@/lib/portfolio-context";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DeskPage from "@/pages/DeskPage";
import DiscoverPage from "@/pages/DiscoverPage";
import PortfoliosPage from "@/pages/PortfoliosPage";
import PortfolioDetailPage from "@/pages/PortfolioDetailPage";
import PocPage from "@/pages/PocPage";
import AdminPage from "@/pages/AdminPage";
import CloakUserPage from "@/pages/CloakUserPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import AuditPage from "@/pages/AuditPage";
import AlpacaSettingsPage from "@/pages/AlpacaSettingsPage";
import CapitalSettingsPage from "@/pages/CapitalSettingsPage";
import OandaSettingsPage from "@/pages/OandaSettingsPage";
import TelegramSettingsPage from "@/pages/TelegramSettingsPage";

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <PortfolioProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/desk" replace />} />
              <Route path="/desk" element={<DeskPage />} />
              <Route path="/desk/:portfolioId" element={<DeskPage />} />
              <Route path="/discover" element={<DiscoverPage />} />
              <Route path="/portfolios" element={<PortfoliosPage />} />
              <Route path="/portfolios/:id" element={<PortfolioDetailPage />} />
              <Route path="/analyze" element={<PocPage />} />
              <Route path="/account/password" element={<ChangePasswordPage />} />
              <Route path="/settings/alpaca" element={<AlpacaSettingsPage />} />
              <Route path="/settings/capital" element={<CapitalSettingsPage />} />
              <Route path="/settings/oanda" element={<OandaSettingsPage />} />
              <Route path="/settings/telegram" element={<TelegramSettingsPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute masterOnly>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/audit"
                element={
                  <ProtectedRoute masterOnly>
                    <AuditPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users/:userId"
                element={
                  <ProtectedRoute masterOnly>
                    <CloakUserPage />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/desk" replace />} />
          </Routes>
        </BrowserRouter>
        </PortfolioProvider>
      </AuthProvider>
      <Toaster theme="dark" position="top-right" richColors offset={72} />
    </div>
  );
}

export default App;
